import React from 'react';
export const ChevronRight = (props) => {
    return (React.createElement("svg", { width: "11", height: "18", viewBox: "0 0 11 18", xmlns: "http://www.w3.org/2000/svg", fill: "none", ...props },
        React.createElement("path", { d: "M1.5 1.5L9 9L1.5 16.5", stroke: "currentColor", strokeWidth: props.strokeWidth ?? '3', strokeLinecap: "square" })));
};
